/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutGrid = createReactComponent("layout-grid", "IconLayoutGrid", [
  [
    "path",
    {
      d: "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-1"
    }
  ],
  [
    "path",
    {
      d: "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-2"
    }
  ],
  [
    "path",
    {
      d: "M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-3"
    }
  ]
]);

export { IconLayoutGrid as default };
//# sourceMappingURL=IconLayoutGrid.js.map
